import { STEP3Actions, STEP3State } from "../interfaces/types";
import { step3Types } from "../constants/actionTypes";
import { RootState } from "./index";

const initialState: STEP3State = {
  pending: false,
  error: null,
  data: null, // 🔧 fixed: null (not []) so empty array isn't treated as a response object
  response: null,
  fileName: "",
  file: "",
  eventId: 0,
  uploadedFileList: [],
};

export default (state = initialState, action: STEP3Actions) => {
  switch (action.type) {
    case step3Types.FETCH_STEP3_REQUEST:
      return {
        ...state,
        pending: true,
        error: null,
        data: null, // 🔧 fixed: clear prior result so effect doesn't re-toast stale success
      };
    case step3Types.FETCH_STEP3_SUCCESS:
      return {
        ...state,
        pending: false,
        data: action.payload,
        error: null,
      };
    case step3Types.FETCH_STEP3_FAILURE:
      return {
        ...state,
        pending: false,
        error: action.payload.error,
        // 🔧 fixed: mirror failure into data so UploadDocumentation toast effect can show it
        data: {
          isSuccess: false,
          errorMessages: [action.payload.error || "Upload failed. Please try again."],
          uploadedFileList: [],
        },
      };
    default:
      return state;
  }
};

export const getSTEP3EnteredDetails = (state: RootState) => state.step3.data;
export const getSTEP3Pending = (state: RootState) => state.step3.pending; // 🔧 fixed: expose pending for submit disabled state
